module.exports = __webpack_public_path__ + "static/img/反三违-架构.3e9ff81c.png";